<template>
    <button @click.prevent="submit()">
        <svg class="heart" :class="{ 'active': isLoved }">
            <use xlink:href="#heart"></use>
        </svg>
        <small>{{ loves.length }}</small>
    </button>
</template>
<script>

import Form from '@/classes/Form'

export default {

    props: ['post', 'comment', 'user'],

    data() {
        return {
            loves: this.comment.loves,
            form: new Form()
        }
    },

    methods: {
        submit() {
            this.form.patch(`/${this.post.slug}/comments/${this.comment.id}/love`)
                .then(response => {
                    this.loves = response.comment.loves
                })
        },
    },

    computed: {
        isLoved() {
            return _.find(this.loves, love => {
                return love.pivot.user_id == this.user.id
            })
        }
    }
}
</script>
